import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { Router } from '@angular/router';
import { cloneDeep } from 'lodash';
import { ProductConfigOpsType, ProductConfigStep } from '../../../../../../core/enums';
import { Bp2ConfigurationRequest, IBuildPakAttribute, V6nestedFrame, V6option } from '../../../../../../core/models';
import { CommonService } from '../../../../../../core/services/common.service';
import { UserService } from '../../../../../../core/services/user.service';
import { V6macroService } from '../../../../../../core/services/v6macro.service';
import { V6productService } from '../../../../../../core/services/v6product.service';
import { V6translationService } from '../../../../../../core/services/v6translation.service';
//import { STD_DR_2DO_UP } from '../../create-configuration/moctData';

@Component({
  selector: 'app-bp2',
  templateUrl: './bp2.component.html',
  styleUrls: ['./bp2.component.scss']
})
export class Bp2Component implements OnInit {
  @Output() outputResponse = new EventEmitter<any>();

  configCreationInProgres: boolean;
  updateConfigRequest: any;
  isFormSubmiited: boolean = false;
  configError: string = '';

  constructor(private v6productService: V6productService,
    private v6translationService: V6translationService,
    private commonService: CommonService,
    private v6MacroService: V6macroService,
    private userService: UserService,
    private router: Router) { console.log('bp2'); }

  get productModel() {
    return this.v6productService.bp2PreviewModel;
  }
  set productModel(pm) {
    this.v6productService.bp2PreviewModel = pm;
  }


  ngOnInit() {
    console.log('bp2');
    //this.initItem();
    //this.v6productService.repositionPPFinIfApplicable(this.productModel);
    //this.v6MacroService.runMacros('pageLoad', this.productModel.bp2Macros, this.productModel);
    //this.productModel.resourceFrame.attributeFiltersForUI = this.v6productService.organizeControlsInTabluarForm(this.productModel.resourceFrame.attributeFilters, false);
    //this.productModel.nestedFrames.forEach((el, index) => {
    //  el.attributeFiltersForUI = this.v6productService.organizeControlsBySection(el.attributeFilters);
    //})
    //this.v6MacroService.attachMacroHelperFunctions(this.productModel);
    this.initErrorModel();
    this.initProductModel();
    var url = this.router.url;
    if (url.includes("configProduct/createConfiguration")) {
      this.v6productService.isInAdminSection = true;
    }
    else {
      this.v6productService.isInAdminSection = false;
    }
    console.log(this.productModel);
  }

  initProductModel() {
    this.initItem();
    this.v6productService.repositionPPFinIfApplicable(this.productModel);
    this.v6MacroService.runMacros('pageLoad', this.productModel.bp2Macros, this.productModel);
    this.productModel.resourceFrame.attributeFiltersForUI = this.v6productService.organizeControlsInTabluarForm(this.productModel.resourceFrame.attributeFilters, false);
    this.productModel.nestedFrames.forEach((el, index) => {
      el.attributeFiltersForUI = this.v6productService.organizeControlsBySection(el.attributeFilters);
    })
    this.v6MacroService.attachMacroHelperFunctions(this.productModel);
  }

  initItem() {
    //show Exterior Finish 
    const eFin = this.productModel.productAttributes.find(x => x.v6ReferenceCode === 'Job/Exterior Finish');
    if (eFin) { eFin.show = true; }
  }

  executeMacro(attrs) {
    if (attrs.type === 'text') {
      this.checkAndPreventNegativeInputIfApplicable(attrs);
    }
    if (attrs.value) { attrs.isError = false; attrs.errorMessage = '' };
    const element = attrs;
    if (element) {
      element.isDirty = true;
      //if list r radio button
      let c = element.options.find(x => x.value === element.value);
      if (c) {
        element.code = c.code;
      }
    }
    this.v6MacroService.attachMacroHelperFunctions(this.productModel);
    let nameMacros: any = [];
    if (this.productModel.configNameExpression) {
      nameMacros.push(this.productModel.configNameExpression);
    }
    this.v6MacroService.runMacros('onChange', this.productModel.bp2Macros, this.productModel);
    if (this.productModel.configNameExpression) {
      this.v6MacroService.runMacros('computeName', nameMacros, this.productModel);
    }
    this.v6productService.buildResourceFrameCode(this.productModel.resourceFrame);
    this.productModel.nestedFrames.forEach((el, index) => {
      this.v6productService.buildNestedFrameCode(el);
    });

    if (this.isFormSubmiited) {
      this.validateBP2();
    }
    else {
      this.checkModelErrors();
    }

    //console.log(attrs);
    //this.testC(attrs.v6ReferenceCode);
  }
  testC(rf) {
    let t = this.productModel.nestedFrames[0].attributeFilters.find(x => x.v6ReferenceCode === rf);
    let t1;// = this.productModel.nestedFrames[0].attributeFiltersForUI[0].find(x => x.v6ReferenceCode === rf);
    this.productModel.nestedFrames[0].attributeFiltersForUI.forEach((ui, i) => {
      if (!t1) {
        t1 = ui.find(x => x.v6ReferenceCode === rf);
      }
    })
    console.log('attrs');
    console.log(t);
    console.log('attrsUI');
    console.log(t1);
  }

  submitConfiguration(onlyUpdate: boolean) {
    this.v6MacroService.runMacros('validate', this.productModel.bp2Macros, this.productModel);
    if (!this.validateBP2()) return;
    //if there is no error then proceed
    this.updateConfiguration(false);

  }
  updateConfiguration(onlyUpdate: boolean) {

    this.configCreationInProgres = true;
    this.updateConfigRequest = new Bp2ConfigurationRequest();
    this.configError = '';
    //update only frame
    //update only nested frame --logic have to be implemented
    //update only config   
    this.updateConfigRequest.configuration.status = this.productModel.status;
    this.updateConfigRequest.configuration.dateCreated = this.productModel.dateCreated;
    this.updateConfigRequest.configuration.originalItemId = this.productModel.originalItemId;
    this.updateConfigRequest.configuration.v6QuoteNumber = this.productModel.v6QuoteNumber;
    let t = this.productModel.nestedFrames.length
    if (t === 1) {
      this.updateConfigRequest.configuration.originalDescription = this.productModel.computedName;
    }
    else {
      this.updateConfigRequest.configuration.originalDescription = this.productModel.originalDescription; //this.productModel.computedName;
    }

    this.updateConfigRequest.configuration.originalDescription = this.productModel.originalDescription;
    this.updateConfigRequest.configuration.reference = this.productModel.reference;
    const q = parseInt(this.productModel.quantity ? this.productModel.quantity.toString() : "1");
    this.updateConfigRequest.configuration.quantity = q;
    this.updateConfigRequest.configuration.customerCode = this.userService.readUserObject.customerNumber.toString(); //this.productModel.customerCode;
    this.updateConfigRequest.configuration.quoteItemCommonId = this.productModel.quoteItemCommonId;
    this.updateConfigRequest.configuration.quoteCommonId = this.productModel.quoteCommonId;
    this.updateConfigRequest.configuration.v6ItemSequenceNumber = this.productModel.v6ItemSequenceNumber;
    this.updateConfigRequest.configuration.unitNetSellPrice = this.productModel.unitNetSellPrice;
    this.updateConfigRequest.configuration.unitGrossSellPrice = this.productModel.unitGrossSellPrice;
    this.updateConfigRequest.configuration.concessionedQuoteCopyCommonId = this.productModel.concessionedQuoteCopyCommonId;
    this.updateConfigRequest.configuration.concessionedQuoteItemCopyCommonId = this.productModel.concessionedQuoteItemCopyCommonId;

    //map configuration related properties, since it will be always included
    this.movePPFinForUpdate();
    let modifiedProductAttributes = this.productModel.productAttributes.filter(x => x.isDirty);
    this.removeAttrForUpdate(modifiedProductAttributes, 'Cross Rails');
    this.removeAttrForUpdate(modifiedProductAttributes, 'Transom');

    //const modifiedResourceFrameAttrs = this.productModel.resourceFrame.attributeFilters.filter(x => x.isDirty);
    let modifiedResourceFrameAttrs = [];
    this.productModel.resourceFrame.attributeFiltersForUI.forEach((f, i) => {
      let t = f.filter(x => x.isDirty);
      if (t && t.length > 0) {
        modifiedResourceFrameAttrs = [...modifiedResourceFrameAttrs, ...t];
      }
    })

    //

    this.updateConfigRequest.outerFrame.quoteWideFrameId = this.productModel.resourceFrame.quoteWideFrameId;

    modifiedProductAttributes.forEach((attr, index) => {
      let opt = new V6option();
      opt.code = this.v6translationService.translateKDToV6(attr.name, attr.v6ReferenceCode);
      opt.value = attr.value;
      opt.listCode = attr.value;
      opt.key = attr.v6ReferenceCode;
      this.updateConfigRequest.outerFrame.options.push(opt);
      if (attr.v6ReferenceCode === 'Job/Exterior Finish') {
        opt = new V6option();
        opt.code = 'Interior Finish';//this.v6translationService.translateKDToV6(attr.name, attr.v6ReferenceCode);
        opt.value = attr.value;
        opt.listCode = attr.value;
        opt.key = 'Interior Finish';//attr.v6ReferenceCode;
        this.updateConfigRequest.outerFrame.options.push(opt);
        opt = new V6option();
        opt.code = 'Billing Finish';//this.v6translationService.translateKDToV6(attr.name, attr.v6ReferenceCode);
        opt.value = attr.value;
        opt.listCode = attr.value;
        opt.key = 'Billing Finish';
        this.updateConfigRequest.outerFrame.options.push(opt);
        // this.createConfigurationRequest.defaultOptions.push({ code: "Interior Finish", value: jobFin.value });
        // this.createConfigurationRequest.defaultOptions.push({ code: "Billing Finish", value: jobFin.value });
      }
    });
    modifiedResourceFrameAttrs.forEach((attr, index) => {
      let opt = new V6option();
      opt.code = this.v6translationService.translateKDToV6(attr.name, attr.v6ReferenceCode);
      opt.value = attr.value;
      opt.listCode = attr.value;
      opt.key = attr.v6ReferenceCode;
      this.updateConfigRequest.outerFrame.frameOptions.push(opt);
    })

    const modifiedNestedFrames = [];
    this.productModel.nestedFrames.forEach((el, fIndex) => {
      this.updateConfigRequest.outerFrame.nestedFrames.push(new V6nestedFrame());
      //const attrs = el.attributeFilters.filter(x => x.isDirty);//old
      let attrs = [];
      el.attributeFiltersForUI.forEach((f, i) => {
        let t = f.filter(x => x.isDirty);
        if (t && t.length > 0) {
          attrs = [...attrs, ...t];
        }
      })
      this.updateConfigRequest.outerFrame.nestedFrames[fIndex].quoteWideFrameId = el.quoteWideFrameId;
      attrs.forEach((attr, index) => {
        let opt = new V6option();
        opt.code = this.v6translationService.translateKDToV6(attr.name, attr.v6ReferenceCode);
        opt.value = attr.value;
        opt.listCode = attr.value;
        opt.key = attr.v6ReferenceCode;
        this.updateConfigRequest.outerFrame.nestedFrames[fIndex].frameOptions.push(opt);
      })
    });

    //if (modifiedProductAttributes && modifiedResourceFrameAttrs && modifiedNestedFrames.length > 0) {
    //  //update all api call
    //  this.productService.updateConfiguration(this.updateConfigRequest).subscribe(resp => {
    //    this.configCreationInProgres = false;
    //  })
    //}
    console.log('test update config request');
    console.log(this.updateConfigRequest);
    //return;
    //////just for test start
    ////this.v6productService.bp3PreviewModel = cloneDeep(this.v6productService.bp2PreviewModel);
    ////let destination = this.v6productService.bp3PreviewModel;
    ////let resp = STD_DR_2DO_UP;
    ////this.v6productService.mapUpdateConfigRequestToProductModel(resp, destination);
    ////this.configCreationInProgres = false;
    ////this.v6productService.currentProductConfigStep = ProductConfigStep.CONFIRM_CONFIG;
    ////return;
    //////just for test end
    this.productModel.erros = [];
    this.v6productService.updateConfigurationServiceX(this.updateConfigRequest).subscribe(resp => {
      this.configCreationInProgres = false;
      if (!resp) {
        console.log('error while updating');
        console.log(resp);
        this.configCreationInProgres = false;
        this.configError = 'Sorry an error occured.Please try again.If error persists then please contact Kawneer Helpdesk';
        return;
      }
      this.productModel.quoteCommonId = resp.configuration.quoteCommonId;
      this.productModel.quoteItemCommonId = resp.configuration.quoteItemCommonId;
      if (this.v6productService.hasError(resp)) {
        let destination = this.productModel;
        this.v6productService.mapCreateConfigRequestToProductModel(resp, destination);
        //this.v6productService.mapUpdateConfigRequestToProductModel(resp, destination);
        //this.outputToParent(resp.configuration.quoteItemCommonId);
        //this.productModel.resourceFrame.attributeFiltersForUI = this.v6productService.organizeControlsInTabluarForm(this.productModel.resourceFrame.attributeFilters, false);
        //this.productModel.nestedFrames.forEach((el, index) => {
        //  el.attributeFiltersForUI = this.v6productService.organizeControlsBySection(el.attributeFilters);
        //})
        this.initProductModel();
        if (resp.messages && resp.messages.length > 0) {
          this.productModel.v6SummaryMessage = [];
          resp.messages.forEach((el, i) => {
            if (el.type && el.type === 2) {
              try {
                this.decryptV6ErrorMessage(el.value);
              }
              catch (e) { }//ignore }
              this.productModel.erros.push(el.value);
            }
            else {
              this.productModel.v6SummaryMessage.push(el.value);
            }
          });
        }
        console.log(this.productModel);
        //console.log(destination);
      }
      else {
        this.v6productService.lastResponse = this.v6productService.curResponse;
        this.v6productService.curResponse = resp;
        let respDiff = this.v6productService.compareUpdateResponse(this.v6productService.lastResponse, this.v6productService.curResponse, this.productModel.translationFamily);
        if (respDiff && respDiff.isDifferent) {

          //new field added...stop on BP2         
          let destination = this.productModel;
          if (!resp.messages) { resp.messages = []; }
          resp.messages.push("Based on your selection, new field added on the form. Please make relevant selection!!!!");
          this.v6productService.mapCreateConfigRequestToProductModel(resp, destination);
          this.initProductModel();
          //highlight those fields
          respDiff.outerFrame.frameOptions.forEach((attr, ind) => {
            let at = this.productModel.resourceFrame.attributeFilters.find(x => x.v6ReferenceCode === attr.key);
            if (at) {
              at.isError = true;
            }
          })
          respDiff.outerFrame.nestedFrames.forEach((nfAttrs, curIn) => {
            if (this.productModel.nestedFrames.length > curIn) {
              nfAttrs.forEach((attr, curIn) => {
                let at = this.productModel.nestedFrames[curIn].attributeFilters.find(x => x.v6ReferenceCode === attr.key);
                if (at) {
                  at.isError = true;
                }
              });
            }
          });
          this.checkModelErrors();
        }
        else {
          this.v6productService.bp3PreviewModel = cloneDeep(this.productModel);
          let destination = this.v6productService.bp3PreviewModel;
          this.v6productService.mapUpdateConfigRequestToProductModel(resp, destination);
          this.outputToParent(this.productModel.quoteItemCommonId);
          //show ppfin on bp3
          const ppFin = destination.productAttributes.find(x => x.v6ReferenceCode === 'PushPull Finish');
          if (ppFin) { ppFin.show = true; }
          this.v6productService.currentProductConfigStep = ProductConfigStep.CONFIRM_CONFIG;//commented for test
        }
      }
    });

  }

  //#region helper functions
  movePPFinForUpdate() {
    const ppFin = this.productModel.productAttributes.find(x => x.v6ReferenceCode === 'PushPull Finish');
    this.productModel.nestedFrames.forEach((el, index) => {
      const p = el.attributeFilters.find(x => x.v6ReferenceCode === 'PushPull Finish');
      if (p && p.isDirty) {
        if (ppFin) {
          ppFin.isDirty = p.isDirty;
          ppFin.value = p.value;
        }
        p.isDirty = false;
      }
    });
  }
  removeAttrForUpdate(attrList: IBuildPakAttribute[], attrName: string) {
    const index = attrList.findIndex(x => x.publishedName === attrName);
    if (index > -1) {
      attrList.splice(index, 1);
    }
  }
  frames = [];
  private selectedCopyFromIndex: number;
  copySettings(frameIndex: number, selectedFromIndex: number) {
    if (selectedFromIndex < 0) {
      return;
    }
    let frameIdexes = [];
    console.log(this.selectedCopyFromIndex);
    this.selectedCopyFromIndex = +selectedFromIndex;//for test only
    let sf = this.productModel.nestedFrames[this.selectedCopyFromIndex];
    let destF = this.productModel.nestedFrames[frameIndex];
    destF.attributeFilters.forEach((el, i) => {
      el.value = sf.attributeFilters[i].value;//search by name instead
      el.code = sf.attributeFilters[i].code;//search by name instead
    })
  }
  //#endregion
  //#region validation & erros

  decryptV6ErrorMessage(msg: string) {
    try {
      const t = msg || '';// 'For Door 2 - !!!WARNING!!! Lock Operator(s) must be specified with the selected lock (Interior or Exterior)["Lock","ExtLckOp","IntLckOp"]';
      let doorIndex: number = 0;
      //if (t.indexOf('For Door ') < 0) return;
      if (t.indexOf('For Door ') === 0 && t.length > 10) {
        let a = t.charAt(9);
        doorIndex = parseInt(a);
        if (doorIndex > 0) { doorIndex = doorIndex - 1; }
        if (!doorIndex) { doorIndex = 0; }
      }
      let f = t.split('[');
      let fields = [];
      if (f.length > 1) {
        fields = f[1].split(',');
      }

      fields.forEach((el, i) => {
        el = el.replace(']', '');
        el = el.replace(/"/ig, '');
        console.log(el);
        if (!isNaN(el)) return;//if it is number then don't proceed
        let attr = this.productModel.resourceFrame.attributeFilters.find(x => x.v6ReferenceCode === el);
        if (attr) {
          attr.isError = true;
          this.productModel.resourceFrame.isError = true;
        }
        else {
          attr = this.productModel.nestedFrames[doorIndex].attributeFilters.find(x => x.v6ReferenceCode === el);
          if (attr) {
            this.productModel.nestedFrames[doorIndex].isError = true;
            attr.isError = true;
          }
        }
        //console.log(attr);
        //this.testC(attr.v6ReferenceCode);
      });
    }
    catch (e) { }//ignore
  }
  validateBP2(): boolean {
    let isFormValid = true;
    this.productModel.productAttributes.forEach((el, index) => {
      if (this.v6productService.isEmpty(el)) { el.isError = true; el.errorMessage = el.publishedName + " is required"; isFormValid = false; }
    });
    this.productModel.resourceFrame.attributeFilters.forEach((el, index) => {
      if (this.v6productService.isEmpty(el)) { el.isError = true; el.errorMessage = el.publishedName + " is required"; isFormValid = false; }
    });
    this.productModel.nestedFrames.forEach((frame, fIndex) => {
      frame.attributeFilters.forEach((el, index) => {
        if (this.v6productService.isEmpty(el)) { el.isError = true; el.errorMessage = el.publishedName + " is required"; isFormValid = false; }
      });
    });
    this.checkModelErrors();
    return isFormValid;
    // return true;
  }
  productErrors: any[] = [];
  resourceFrameErrors: any[] = [];
  nestedFrameErrors: any[] = []
  initErrorModel() {
    this.productErrors = [];
    this.resourceFrameErrors = [];
    this.productModel.nestedFrames.forEach((el, i) => {
      this.nestedFrameErrors.push([]);
    })
  }
  checkModelErrors() {
    this.checkPproductAttrError();
    this.checkResourceFrameError();
    this.checkNestedFrameError();
  }
  checkPproductAttrError() {
    this.productErrors = this.productModel.productAttributes.filter(x => x.isError);
    this.generalTabError = this.productErrors.length > 0 ? true : false;
  }
  checkResourceFrameError() {
    this.resourceFrameErrors = this.productModel.resourceFrame.attributeFilters.filter(x => x.isError);
    this.productModel.resourceFrame.isError = this.resourceFrameErrors.length > 0 ? true : false;
  }
  checkNestedFrameError() {
    this.nestedFrameErrors = [];
    this.productModel.nestedFrames.forEach((nf, i) => {
      let errors = nf.attributeFilters.filter(x => x.isError);
      nf.isError = errors.length > 0 ? true : false;
      this.nestedFrameErrors.push(errors);
    });
    //console.log(n)
  }

  //#endregion
  goBack() {
    this.v6productService.currentProductConfigStep = ProductConfigStep.BASE_CONFIG;
  }
  outputToParent(quoteItemCommonId) {
    this.outputResponse.emit(quoteItemCommonId);
  }

  showBackBtn() {
    if (this.v6productService.currentConfigOPsType === ProductConfigOpsType.EDIT ||
      this.v6productService.currentConfigOPsType === ProductConfigOpsType.COPY) { return false; }
    else { if (this.productModel.bypassBaseConfig) return false; }
    return true;
  }


  generalTabClicked: boolean = true;
  generalTabError: boolean = false;
  selectedIndex = 0;
  onTabSelect(e) {
    console.log(e);
    switch (e.index) {
      case 0:
        this.generalTabClicked = true;
        break;
      case 1:
        this.productModel.resourceFrame.clicked = true;
        break;
      default:
        if (e.index < 2) return;
        let doorIndex = parseInt(e.index) - 2;
        if ((doorIndex) > -1) {
          this.productModel.nestedFrames[doorIndex].clicked = true;
        }
        break;
    }
  }

  checkAndPreventNegativeInputIfApplicable(attr) {
    let v = attr.value;
    if (v) {
      v = v.replace(/-/g, '');
      attr.value = v;
    }
  }
}
